<template>
  <div>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <v-dialog
      v-if="aktifmi"
      persistent
      max-width="1000px"
      v-model="dialog"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-card-title style="background-color:#01579B">
          <span class="headline white--text" v-if="islemTipi == 0"
            >Yolcu Bilgisi</span
          >
          <span class="headline white--text" v-if="islemTipi == 1"
            >Satıcı Bilgisi</span
          >
        </v-card-title>
        <v-card-text class="pa-4">
          <v-layout wrap>
            <v-flex xs12 sm12 md12 v-if="islemTipi == 0">
              <v-data-table
                :headers="headersKisiList"
                :rows-per-page-items="[20, 100]"
                :items="rezervasyonData"
                :loading="loadingData"
              >
                <v-progress-linear
                  v-slot:progress
                  color="blue"
                  indeterminate
                ></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <tr item>
                    <td class="text-xs-left">{{ props.item.adSoyad }}</td>
                    <td class="text-xs-left">{{ props.item.eMail }}</td>
                    <td class="text-xs-left">{{ props.item.gsm }}</td>
                    <td class="text-xs-left">
                      {{ props.item.dogumTarihi | dateformat }}
                    </td>
                    <td class="text-xs-left">{{ props.item.tcKimlikNo }}</td>
                    <td class="text-xs-left">{{ props.item.adres }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
            <v-flex xs12 sm12 md12 v-if="islemTipi == 1">
              <v-data-table
                :headers="headersSaticiList"
                :rows-per-page-items="[20, 100]"
                :items="rezervasyonData"
                :loading="loadingData"
              >
                <v-progress-linear
                  v-slot:progress
                  color="blue"
                  indeterminate
                ></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <tr item>
                    <td class="text-xs-left">{{ props.item.kod }}</td>
                    <td class="text-xs-left">{{ props.item.isim }}</td>
                    <td class="text-xs-left">{{ props.item.cariKod }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click.native="cancel" outline>{{$t('Close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tool from "@/components/app/coper/tools";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import helpers from "@/components/app/customcomp/helpers.js";

export default {
  props: {
    islemTipi: {
      type: Number,
    },
    aktifmi: {
      type: Boolean,
      default: false,
    },
  },
   data() {
        return {
    rezervasyonData: [],
    headersSaticiList: [
      {
        text: this.$t('Code'),
        align: "left",
      },
      {
        text: this.$t('Name'),
        align: "left",
      },
      {
        text: this.$t('Currentcode_label'),
        align: "left",
      },
    ],
    headersKisiList: [
      {
        text: this.$t('Name_Surname_label'),
        align: "left",
      },
      {
        text: this.$t('Email_label'),
        align: "left",
      },
      {
        text: this.$t('Telephone'),
        align: "left",
      },
      {
        text: this.$t('Date-of-Birth'),
        align: "left",
      },
      {
        text: this.$t('Identitynumber_label'),
        align: "left",
      },
      {
        text: this.$t('Address_label'),
        align: "left",
      },
    ],
    loadingData: true,
    dialog: false,
    valid: false,
    text1: "",
    snackbar: false,
    }
  },
  beforeMount: beforeMount,
  components: {
    snackbarcomp,
  },
  methods: {
    open(value) {
        this.loadingData = true
      this.rezervasyonData = [];
      let params = {
        PNR_No: value.PNR_No,
      };
      this.loadingvmodel = true;
      tool.http_post(this, "RezervasyonLoad", params).then(
        (response) => {
          if (response.body.Status == true) {
            if (this.islemTipi == 0) {
              this.rezervasyonData = response.body.data.adresler;
              this.loadingData = false;
            } else if (this.islemTipi == 1) {
              for (var i = 0; i < response.body.data.kalemler.length; i++) {
                this.rezervasyonData.push({
                  kod: response.body.data.kalemler[i].satici.kod,
                  isim: response.body.data.kalemler[i].satici.isim,
                  cariKod: response.body.data.kalemler[i].satici.CariKod,
                });
              }
              this.loadingData = false;
            }
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.HataYonetimi(response, params, "Rezervasyon Getirilemedi");
        }
      );

      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
    },
  },
  filters: {
    dateformat: function(t) {
      return helpers.dateformat(t);
    },
    moneyformat: function(m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function(m) {
      return helpers.bakiyekontrol(m);
    },
  },
};

function beforeMount() {
  //Rezervasyon Load Yapılacak
}
</script>

<style></style>
